import React, { useEffect, useRef } from 'react'
import Link from 'next/link'
import echarts from 'echarts'
import classNames from 'classnames'

interface IProps {
  jumpTo?: string
  option: any
  className?: string
}
export default function RadarChart(props: IProps) {
  const { className, jumpTo, option } = props
  const ref = useRef<HTMLDivElement | null>(null)
  useEffect(() => {
    const dom = ref.current
    if (dom) {
      const myChart = echarts.init(dom)
      myChart.setOption(option)
    }
  }, [option])

  return jumpTo ? (
    <Link href={jumpTo}>
      <div ref={ref} className={classNames(className)} />
    </Link>
  ) : (
    <div ref={ref} className={classNames(className)} />
  )
}
